"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/Button"));
const FormErrors_1 = __importDefault(require("chaire-lib-frontend/lib/components/pageParts/FormErrors"));
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
const TrError_1 = __importDefault(require("chaire-lib-common/lib/utils/TrError"));
const ExportInterviewData = ({ t, i18n }) => {
    const [error, setError] = (0, react_1.useState)(undefined);
    const [isPreparingCsvExportFiles, setIsPreparingCsvExportFiles] = (0, react_1.useState)(false);
    const [csvExportFilesReady, setCsvExportFilesReady] = (0, react_1.useState)(false);
    const [csvExportFilePaths, setCsvExportFilePaths] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        updateOrWaitForFiles(false);
    }, []);
    const onPrepareCsvRespondentExportFiles = () => __awaiter(void 0, void 0, void 0, function* () {
        return onPrepareCsvExportFiles('participant');
    });
    const onPrepareCsvCorrectedExportFiles = () => __awaiter(void 0, void 0, void 0, function* () {
        return onPrepareCsvExportFiles('correctedIfAvailable');
    });
    const onPrepareCsvExportFiles = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (exportType = 'correctedIfAvailable') {
        setIsPreparingCsvExportFiles(true);
        try {
            const response = yield fetch('/api/admin/data/prepareCsvFileForExportBySurveyObject?responseType=' + exportType, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                updateOrWaitForFiles();
            }
            else {
                throw new TrError_1.default('Wrong response status ' + response.status, 'prepareNoResponse', response.status >= 500
                    ? 'admin:export:ServerErrorForExport'
                    : response.status === 401
                        ? 'admin:export:ServerExportForbidden'
                        : 'admin:export:PrepareDataError');
            }
        }
        catch (err) {
            console.log('Error preparing export files.', err);
            // Show the error message to the user
            if (TrError_1.default.isTrError(err)) {
                const { localizedMessage } = err.export();
                setError(localizedMessage.toString());
            }
            else {
                setError('admin:export:PrepareDataError');
            }
            setCsvExportFilesReady(false);
            setCsvExportFilePaths([]);
            setIsPreparingCsvExportFiles(false);
        }
    });
    const updateOrWaitForFiles = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (listenForFiles = true) {
        try {
            const response = yield fetch('/api/admin/data/getExportTaskResults', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const status = yield response.json();
                if (Status.isStatusOk(status)) {
                    const { taskRunning, files } = Status.unwrap(status);
                    setCsvExportFilesReady(!taskRunning);
                    setCsvExportFilePaths(files);
                    setError(undefined);
                    setIsPreparingCsvExportFiles(taskRunning);
                    if (taskRunning && listenForFiles) {
                        setTimeout(updateOrWaitForFiles, 10000);
                    }
                }
                else {
                    throw status.error;
                }
            }
            else {
                throw new TrError_1.default('Wrong response status ' + response.status, 'updateOrWaitResponse', response.status >= 500
                    ? 'admin:export:ServerErrorForExport'
                    : response.status === 401
                        ? 'admin:export:ServerExportForbidden'
                        : 'admin:export:UpdateOrWaitError');
            }
        }
        catch (err) {
            console.log('Error fetching export files.', err);
            // Show the error message to the user
            if (TrError_1.default.isTrError(err)) {
                const { localizedMessage } = err.export();
                setError(localizedMessage.toString());
            }
            else {
                setError('admin:export:WaitForFileError');
            }
            setCsvExportFilesReady(false);
            setCsvExportFilePaths([]);
            setIsPreparingCsvExportFiles(false);
        }
    });
    // This function is used to download the survey questionnaire list as a .txt file
    // NOTE: It is not related to the CSV export files, but it is included here for convenience
    const downloadSurveyQuestionnaireListTxt = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const lang = i18n.language; // Use i18n to get the current language
            const apiUrl = `/api/admin/data/downloadSurveyQuestionnaireListTxt?lang=${lang}`;
            const response = yield fetch(apiUrl, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                setError(undefined);
                // Create a blob from the response and create a link to download it
                const blob = yield response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `questionnaire_list_${lang}.txt`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            else if (response.status === 404) {
                throw new TrError_1.default('Wrong response status ' + response.status, 'downloadSurveyQuestionnaireListNotFound', 'admin:export:DownloadSurveyQuestionnaireListNotFound');
            }
            else if (response.status === 401) {
                throw new TrError_1.default('Wrong response status ' + response.status, 'downloadSurveyQuestionnaireListUnauthorized', 'admin:export:DownloadSurveyQuestionnaireListUnauthorized');
            }
            else {
                throw new TrError_1.default('Wrong response status ' + response.status, 'downloadSurveyQuestionnaireListError', 'admin:export:DownloadSurveyQuestionnaireListError');
            }
        }
        catch (err) {
            console.log('Error downloading survey questionnaire list.', err);
            // Show the error message to the user
            if (TrError_1.default.isTrError(err)) {
                const { localizedMessage } = err.export();
                setError(localizedMessage.toString());
            }
            else {
                setError('admin:export:DownloadSurveyQuestionnaireListError');
            }
        }
    });
    const onRefreshExportFiles = () => updateOrWaitForFiles(false);
    const csvFileExportLinks = csvExportFilePaths.map((csvFilePath) => (react_1.default.createElement("li", { key: csvFilePath },
        react_1.default.createElement("a", { href: `/api/admin/data/exportcsv/${csvFilePath.startsWith('exports/') ? csvFilePath : 'exports/' + csvFilePath}` }, csvFilePath))));
    return (react_1.default.createElement("div", { className: "admin-widget-container" },
        isPreparingCsvExportFiles && react_1.default.createElement(LoadingPage_1.default, null),
        react_1.default.createElement(Button_1.default, { color: "blue", onClick: onPrepareCsvCorrectedExportFiles, label: t('admin:export:PrepareCorrectedCsvExportFiles'), align: "left" }),
        react_1.default.createElement(Button_1.default, { color: "blue", onClick: onPrepareCsvRespondentExportFiles, label: t('admin:export:PrepareParticipantCsvExportFiles'), align: "left" }),
        react_1.default.createElement(Button_1.default, { color: "green", onClick: downloadSurveyQuestionnaireListTxt, label: t('admin:export:DownloadSurveyQuestionnaireListTxt'), align: "left" }),
        error && react_1.default.createElement(FormErrors_1.default, { errors: [error] }),
        csvExportFilesReady && react_1.default.createElement("ul", null, csvFileExportLinks),
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { onClick: onRefreshExportFiles, style: { cursor: 'pointer' } }, t('admin:export:RefreshExportFiles'))))));
};
exports.default = (0, react_i18next_1.withTranslation)()(ExportInterviewData);
//# sourceMappingURL=ExportInterviewData.js.map